/**
 * Calendar integration domain — entity types and helpers.
 *
 * Re-exports the generated entity types so consumers import everything
 * from `services/calendar-integration`.
 */

import type { Calendar } from '../generated/types/Calendar'
import type { ISelectItem } from '../../components/UI/Select/Select'

export type { Calendar } from '../generated/types/Calendar'
export type { ExpandedEvent } from '../generated/types/ExpandedEvent'
export type { CalendarDetailResponse } from '../generated/types/CalendarDetailResponse'

/**
 * Backwards-compatible alias for legacy `CalendarOption` shape used
 * across `features/settings/`. Identical to the generated `Calendar`.
 */
export type CalendarOption = Calendar

export function toCalendarSelectItems(
  calendars: Calendar[]
): ISelectItem<number>[] {
  return calendars.map((cal) => ({
    label: `${cal.name}${cal.is_primary ? ' (Primary)' : ''}`,
    value: cal.id,
  }))
}
